import { useContext } from 'react';
import { SiteContext } from '../../contexts/site';
export const useSiteContext = () => {
    const { site } = useContext(SiteContext);
    if (!site) {
        throw new Error('useSiteContext should be used within SiteContext');
    }
    return site;
};
